import { FormattedMessage } from 'react-intl'
import { NavLink } from 'react-router-dom'

import { TabsWrapper, Tabs, Tab } from 'components/Tabs'
import { ReactElement } from 'react'

export const CouponTabs = (): ReactElement => {
  return (
    <TabsWrapper>
      <Tabs>
        <Tab as={NavLink} to="/coupons" end>
          <FormattedMessage id="coupons.tabs.tickets" defaultMessage="Tickets" />
        </Tab>

        <Tab as={NavLink} to="/coupons/snacks" end>
          <FormattedMessage id="coupons.tabs.snacks" defaultMessage="Snacks" />
        </Tab>
      </Tabs>
    </TabsWrapper>
  )
}
